export default {
    clear() {
        let style = this.get('dataStyle');
        localStorage.clear();
        localStorage.setItem('dataStyle', style);
    },
    set(key, val) {
        if (!window.localStorage) {
            sessionStorage.setItem(key, val);
        } else {
            localStorage.setItem(key, val);
        }
    },
    get(key) {
        if (!window.localStorage) {
            sessionStorage.getItem(key);
        } else {
            return localStorage.getItem(key);
        }
    },
    setSearch(search) {
        let jsonStr = JSON.stringify(search);
        this.set(`search${search.zhaoPin.Id}`, jsonStr);
    },
    getSearch(id) {
        let search = this.get(`search${id}`);
        if (search) {
            return JSON.parse(search);
        }
        return '';
    },
    setExpert(expert) {
        let jsonStr = JSON.stringify(expert);
        jsonStr = jsonStr.replace('":', "file&_");
        jsonStr = jsonStr.replace('","', "column|sel");
        this.set(`Expert_${expert.Id}`, jsonStr);
    },
    getExpert(id) {
        let expert = this.get(`Expert_${id}`);
        if (expert) {
            expert = expert.replace("file&_", '":');
            expert = expert.replace("column|sel", '","');
            return JSON.parse(expert);
        }
        return '';
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/storage.js
// module id = null
// module chunks = 